import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfterSection() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-85" data-mp="3ahk5zrqa9uxp">
      <div className="mx-auto max-w-6xl" data-id="element-86" data-mp="3fflmc4wbrg5h">
        <SectionHeading kicker="From second-guessing to a clear clinical process" title="You don't need more information. You need a better way to organize it." intro="Many dental professionals understand the fundamentals but still feel uncertain reviewing a new setup. The problem isn't always knowledge — it's the absence of a repeatable process." data-id="element-87" data-mp="3fgmzqg0tceqd" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-88" data-mp="267cibbchyvk">
          <div className="rounded-3xl border-2 border-alert/40 bg-alert/[0.08] p-5 sm:p-8" data-id="element-89" data-mp="pwjukf0b1bzv">
            <div className="flex items-center gap-3" data-id="element-90" data-mp="upd0v7bf8se2">
              <span className="rounded-full bg-alert px-4 py-1.5 text-sm font-black uppercase text-white" data-id="element-91" data-mp="uq625srm2pot">Before</span>
              <span className="text-sm font-semibold text-white/70" data-id="element-92" data-mp="1xp9qftmh1mxw">Improvised review</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-93" data-mp="2cefovfdhj94q">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-white/90" data-id="element-94" data-mp="27nh1jvu2xarz">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/20" data-id="element-95" data-mp="2lec6ix1gj7qa">
                    <XIcon className="h-4 w-4 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="2ggakq4cncub4" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/50 bg-cta/[0.08] p-5 sm:p-8" data-id="element-97" data-mp="2qeqbu7boc3km">
            <div className="flex items-center gap-3" data-id="element-98" data-mp="10xz5xc2q2ad4">
              <span className="rounded-full bg-cta px-4 py-1.5 text-sm font-black uppercase text-ink" data-id="element-99" data-mp="110lkhvo15q4u">After</span>
              <span className="text-sm font-semibold text-white/70" data-id="element-100" data-mp="1lntbzzyh9i97">With The ClinCheck Blueprint™</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-101" data-mp="1pomwskgmigxv">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[17px] font-semibold leading-snug text-white" data-id="element-102" data-mp="1unyh23g784k7">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-103" data-mp="1zo43n57m30vf">
                    <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-104" data-mp="24lmdqyxd7m50" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xl font-bold text-white" data-id="element-105" data-mp="2dfr8htfmdhpt">
          My goal is simple: replace an improvised review process with a{" "}
          <span className="text-brand" data-id="element-106" data-mp="2ne84x5xbuoj9">structured clinical workflow.</span>
        </p>

        <div className="mt-8" data-id="element-107" data-mp="2sbgo99u7oym3">
          <CTAButton label="I want a more structured review process" data-id="element-108" data-mp="2scrpp306pua1" />
        </div>
      </div>
    </section>;
}